import Banner from "../components/ui/Banner";
import NavBar from "../components/Nav/NavBar";
import stockBanner from '../assets/images/stock-banner.jpeg'
import AboutContent from "../components/About/AboutContent";
import Footer from "../components/Footer";
import Enquire from "../components/Enquire";

export default function About() {
  return ( 
    <div id='root' className="p-4">
      <NavBar />
      <Banner image={stockBanner} caption="About us" />
      <AboutContent />
      <Enquire />
      <Footer />
    </div>
  );
}